import type { SuspensionAction } from '@/client/services/user'

const HANDWRITTEN_SUSPENSION_NOTE_RELEASE_DATE = new Date('2025-10-16')

export default function shouldShowSuspensionNote(
  suspensionAction: Pick<SuspensionAction, 'note' | 'timestamp'>
): boolean {
  const date = new Date(suspensionAction.timestamp)
  return suspensionAction.note != null && date > HANDWRITTEN_SUSPENSION_NOTE_RELEASE_DATE
}
